export default __webpack_public_path__ + "static/media/card-theme3.58808031.svg";